// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"383":"c4f5922a","456":"c4f5922a","515":"20c9aad8","597":"1ab53ddd","712":"4d514a52"}[chunkId] + ".chunk.css";
};